<div class="panel">
	<div class="heading">Adjustment History</div>
	<div class="content nopad">
		@if (adjustments && !adjustments.length) {
			<div class="p-3">
				No adjustments have been recorded for this rotor
			</div>
		}
		@if (adjustments && adjustments.length) {
			<div>
				<div class="p-3">Rotor blades: {{blades}}</div>
				<table class="log openborders paneled adjustment-history">
					<thead>
						<tr>
							<th>Operation</th>
							<th>Entered by</th>
							@for (adjdef of rotor.adjdef; track adjdef) {
								<th>{{adjdef | adjdeflabel}}</th>
							}
							<th>User note</th>
							@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
								<th>
									Delete</th>
							}
						</tr>
					</thead>
					@if (adjustmentSums) {
						<tbody class="highlight-row">
							<tr>
								<td colspan="2">Adjustment Totals</td>
								@for (adjdef of rotor.adjdef; track $index) {
									<td>{{adjustmentSums[$index]}}</td>
								}
								<td></td>
								@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
									<td></td>
								}
							</tr>
						</tbody>
					}
					@for (adjustment of adjustments; track adjustment) {
						<tbody>
							<tr>
								<td>{{adjustment.operation_start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0) }}</td>
								<td>{{adjustment.author_email}}</td>
								@for (adjdef of rotor.adjdef; track $index) {
									<td>{{adjustment.adjustments.split('|')[$index] | commalist}}</td>
								}
								<td [title]="adjustment.user_note"><span>{{adjustment.user_note}}</span></td>
								@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
									<td>
										<app-action-button [action]="DeleteAdjustment" [args]="[adjustment.adjustment_history_id]" [context]="this" btnClass="icon red" confirm="Are you sure?"
											processing="..."><i class="icon-trash"></i></app-action-button>
									</td>
								}
							</tr>
						</tbody>
					}
					@if (baseline) {
						<tbody class="highlight-row">
							<tr>
								<td>Adjustment Baseline</td>
								<td>{{baseline.author_email}}</td>
								@for (adjdef of rotor.adjdef; track $index) {
									<td>{{baseline.adjustments.split('|')[$index] | commalist}}</td>
								}
								<td></td>
								@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
									<td>
										<app-action-button [action]="DeleteBaseline" [context]="this" btnClass="icon red" confirm="Are you sure?" processing="..."><i
												class="icon-trash"></i></app-action-button>
									</td>
								}
							</tr>
						</tbody>
					}
					@else if (createBaseline.observers.length && !isH60) {
						<tbody class="highlight-row">
							<tr>
								<td>Adjustment Baseline</td>
								<td></td>
								@for (adjdef of rotor.adjdef; track $index) {
									<td></td>
								}
								<td></td>
								@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
									<td>
										<app-action-button [action]="CreateBaseline" [context]="this" btnClass="icon green" processing="..."><i class="icon-plus"></i></app-action-button>
									</td>
								}
							</tr>
						</tbody>
					}
				</table>
			</div>
		}
	</div>
</div>